import { render, staticRenderFns } from "./normalGoodsStoreUpload.vue?vue&type=template&id=47b7ecbb"
import script from "./normalGoodsStoreUpload.vue?vue&type=script&lang=js"
export * from "./normalGoodsStoreUpload.vue?vue&type=script&lang=js"
import style0 from "./normalGoodsStoreUpload.vue?vue&type=style&index=0&id=47b7ecbb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports